import classNames from "classnames";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";
import { InputTextarea } from "primereact/inputtextarea";
import React, { useEffect, useState } from "react";
import { SelectButton } from "primereact/selectbutton";

export default function Panel_A({ data, setData, commentList, onUploadDialog, uploadPic, disabledPage }) {
    // const [data, setData] = useState({
    //     engineerCheckbox : "N",
    //     engineerCount : "",
    //     engineerPhotoPath :"pic.jpg",
    //     foremanCheckbox : "N",
    //     foremanCount :"",
    //     pipeFitterCheckbox : "N",
    //     pipeFitterCount : "",
    //     workerCheckbox : "N",
    //     workerCount : "",
    //     truckCheckbox :"N",
    //     backhoeCheckbox : "N",
    //     sandCompactorCheckbox : "N",
    //     pumpCheckbox : "N",
    //     otherCheckbox : "N",
    //     otherText : "",
    //     commentOnWorker : "", // ความเห็นแรงงาน
    //     commentEngineer :"N",
    //     commentForeman : "N",
    //     commentPipeFitter :"N",
    //     commentTools:"", // เครื่องจักร
    //     commentBackhoe :"N",
    //     commentSandCompactor : "N",
    //     commantPump : "N",
    //     commentOther : "N"

    // });

    const pumbStatusOptions = [
        { label: "ผ่าน", value: "1" },
        { label: "ไม่ผ่าน", value: "2" },
    ];

    const commentOnWorkerOptions = [
        { label: "เพียงพอ", value: "Y" },
        { label: "ไม่พบผู้ปฏิบัติงาน ดังนี้", value: "N" },
    ];

    const commentToolsOptions = [
        { label: "เพียงพอ", value: "Y" },
        { label: "ปรับปรุง/แก้ไข", value: "N" },
    ];

    const onInputTextChange = (e, key, id) => {
        const type = (e.target && e.target.type) || "";
        let val = (e.target && e.target.value) || "";
        const pattern = (e.target && e.target.pattern) || "";

        if (pattern !== "") {
            val = val.replace(/\D/, "");
        }

        if (type === "checkbox") {
            if (e.checked) {
                setData({
                    ...data,
                    [`${key}`]: val,
                });
            } else
                setData({
                    ...data,
                    [`${key}`]: "N",
                    [`${id}`]: "0",
                });
        } else {
            setData({
                ...data,
                [`${key}`]: val,
                [`${id}`]: val !== "" && val !== "0" && val !== null ? "Y" : "N",
            });
        }
    };

    const onCommentOnWorkerChange = (e, key) => {
        const val = (e.target && e.target.value) || "";
        if (val === "1") {
            setData({
                ...data,
                commentEngineer: "N",
                commentForeman: "N",
                commentPipeFitter: "N",
                [`${key}`]: val,
            });
        } else {
            setData({
                ...data,
                [`${key}`]: val,
            });
        }
    };

    const onCommentToolsChange = (e, key) => {
        const val = (e.target && e.target.value) || "";
        if (val === "1") {
            setData({
                ...data,
                commentBackhoe: "N",
                commentSandCompactor: "N",
                commantPump: "N",
                commentOther: "N",
                [`${key}`]: val,
            });
        } else {
            setData({
                ...data,
                [`${key}`]: val,
            });
        }
    };

    useEffect(() => {
        // if(dataTable){
        //     setData(dataTable);
        // }
    }, [data]);

    // useEffect(() => {
    //     if(dataTable){
    //         setData(dataTable);
    //     }
    // }, [])

    // data, setData

    const display_mode = () => {
        return data.displayMode === "Y" ? true : false;
    };

    const renderLeft = () => {
        return commentList.map((item, index) => {
            // console.log(index , item);
            return (
                <>
                    <div className={"p-grid p-fluid " + classNames({ "p-no-box": item.box === false })} key={index}>
                        <div className="p-col-12 p-md-4">
                            <div className="p-field-checkbox">
                                <Checkbox disabled={disabledPage} inputId={"check_" + item.id} name={item.id} value="Y" checked={data[item.id] === "Y"} onChange={(e) => onInputTextChange(e, item.id, item.boxid)} />
                                <label>{item.label}</label>
                            </div>
                        </div>
                        <div className="p-col-12 p-md-4">
                            {item.box === true && item.unit === true ? (
                                <div className="p-field-checkbox">
                                    <InputText
                                        //  placeholder={"จำนวน " + item.label}
                                        id={item.boxid}
                                        onChange={(e) => onInputTextChange(e, item.boxid, item.id)}
                                        // disabled={data[item.id] === "Y" ? false : true}
                                        value={data[item.boxid]}
                                        type="text"
                                        maxLength="3"
                                        pattern="/\D/"
                                    />
                                    <label htmlFor="">{item.id === "truckCheckbox" || item.id === "backhoeCheckbox" ? "คัน" : item.id === "sandCompactorCheckbox" || item.id === "pumpCheckbox" ? "เครื่อง" : "คน"}</label>
                                </div>
                            ) : item.box === true && item.unit === false ? (
                                <div className="p-field-checkbox">
                                    {item.boxid === "otherText" ? (
                                        <InputTextarea
                                            placeholder={item.label}
                                            id={item.boxid}
                                            value={data[item.boxid]}
                                            rows={3}
                                            cols={30}
                                            autoResize
                                            maxLength="5000"
                                            onChange={(e) => onInputTextChange(e, item.boxid)}
                                            //disabled={data[item.id] === "Y" ? false : true}
                                        />
                                    ) : (
                                        <InputText placeholder={item.label} id={item.boxid} value={data[item.boxid]} onChange={(e) => onInputTextChange(e, item.boxid)} disabled={data[item.id] === "Y" ? false : true} maxLength="500" type="text" />
                                    )}
                                </div>
                            ) : (
                                ""
                            )}
                        </div>
                        <div className="p-col-12 p-md-2">
                            {data[item.id] === "Y" && !display_mode() ? (
                                <img title="อัปโหลดรูป" alt="อัปโหลดรูป" src="assets/layout/images/Upload_a_picture.png" style={{ width: 35, height: 35 }} onClick={() => uploadPic(item.codePic)} />
                            ) : (
                                <img title="อัปโหลดรูป" alt="อัปโหลดรูป" src="assets/layout/images/Upload_a_picture.png" style={{ width: 35, height: 35 }} />
                            )}

                            {/* <Button className="p-button-info p-button p-md-12 " icon="pi pi-image" label="รูปถ่าย" disabled={data[item.id] === "Y" ? false : true} style={{ marginLeft: "5px" }} onClick={() => onUploadDialog(item.codePic)} /> */}
                            {data[item.id] === "Y" ? (
                                <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} onClick={() => onUploadDialog(item.codePic)} />
                            ) : (
                                <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} />
                            )}
                        </div>

                        {/* <div className="p-col-12 p-md-1">
                            <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} onClick={() => onUploadDialog(item.codePic)} />
                        </div> */}
                    </div>
                    {item.id === "pumpCheckbox" ? (
                        <>
                            <div className={"p-grid p-fluid p-no-box"} key={index + "xx"}>
                                <div className="p-col-12 "></div>
                                <div className="p-col-12 p-md-12">
                                    <div className="p-field-checkbox">
                                        <label>ความสมบูรณ์ของอุปกรณ์</label>
                                    </div>
                                </div>

                                <div className="p-col-12 p-md-1"></div>
                                <div className="p-col-12 p-md-6">
                                    <div className="flex justify-content-center">
                                        <SelectButton optionLabel="label" options={pumbStatusOptions} value={data.pumbStatusCheckbox} onChange={(e) => onInputTextChange(e, "pumbStatusCheckbox")} optionValue="value" disabled={data[item.id] === "N" || disabledPage} />
                                    </div>
                                    {/* <div className="p-field-radiobutton" style={{ marginTop: "0.45rem", marginBottom: "0.45rem" }}>
                                        <RadioButton
                                            inputId="pumbStatusCheckbox_1"
                                            name="pumbStatusCheckbox"
                                            value="1"
                                            onChange={(e) => onInputTextChange(e, "pumbStatusCheckbox")}
                                            checked={data.pumbStatusCheckbox === "1" ? true : false}
                                            disabled={data[item.id] === "N" || disabledPage}
                                            //className="p-invalid" className={classNames({ "p-invalid": submitted && !data.status })}
                                        />
                                        <label htmlFor="pumbStatusCheckbox1" style={{ marginRight: ".5rem" }}>
                                            ผ่าน
                                        </label>
                                    </div> */}
                                </div>
                                {/* <div className="p-col-12 p-md-2">
                                    <div className="p-field-radiobutton" style={{ marginTop: "0.45rem", marginBottom: "0.45rem" }}>
                                        <RadioButton
                                            inputId="pumbStatusCheckbox_2"
                                            name="pumbStatusCheckbox"
                                            value="2"
                                            onChange={(e) => onInputTextChange(e, "pumbStatusCheckbox")}
                                            checked={data.pumbStatusCheckbox === "2" ? true : false}
                                            disabled={data[item.id] === "N" || disabledPage}
                                            //className="p-invalid" className={classNames({ "p-invalid": submitted && !data.status })}
                                        />
                                        <label htmlFor="pumbStatusCheckbox2" style={{ marginRight: ".5rem" }}>
                                            ไม่ผ่าน
                                        </label>
                                    </div>
                                </div> */}
                                {/* <div className="p-col-12 p-md-3">
                                    <div className="p-field-radiobutton" style={{ marginTop: "0.45rem", marginBottom: "0.45rem" }}>
                                        <RadioButton
                                            inputId="pumbStatusCheckbox_3"
                                            name="pumbStatusCheckbox"
                                            value="3"
                                            onChange={(e) => onInputTextChange(e, "pumbStatusCheckbox")}
                                            checked={data.pumbStatusCheckbox === "3" ? true : false}
                                            disabled={data[item.id] === "N" || disabledPage}
                                            //className="p-invalid" className={classNames({ "p-invalid": submitted && !data.status })}
                                        />
                                        <label htmlFor="pumbStatusCheckbox3" style={{ marginRight: ".5rem" }}>
                                            ไม่ได้ตรวจ
                                        </label>
                                    </div>
                                    
                                </div> */}
                            </div>
                            <div className={"p-grid p-fluid p-no-box"} key={index + "xx"}>
                                <div className="p-col-12"></div>
                                <div className="p-col-12 p-md-12">
                                    <div className="p-field-checkbox">
                                        <label>ความพร้อมใช้งาน</label>
                                    </div>
                                </div>

                                <div className="p-col-12 p-md-1"></div>
                                <div className="p-col-12 p-md-6">
                                    <div className="flex justify-content-center">
                                        <SelectButton optionLabel="label" options={pumbStatusOptions} value={data.pumpReadyToUseCheckbox} onChange={(e) => onInputTextChange(e, "pumpReadyToUseCheckbox")} optionValue="value" disabled={data[item.id] === "N" || disabledPage} />
                                    </div>
                                    {/* <div className="p-field-radiobutton" style={{ marginTop: "0.45rem", marginBottom: "0.45rem" }}>
                                        <RadioButton
                                            inputId="pumpReadyToUseCheckbox_1"
                                            name="pumpReadyToUseCheckbox"
                                            value="1"
                                            onChange={(e) => onInputTextChange(e, "pumpReadyToUseCheckbox")}
                                            checked={data.pumpReadyToUseCheckbox === "1" ? true : false}
                                            disabled={data[item.id] === "N" || disabledPage}
                                            //className="p-invalid" className={classNames({ "p-invalid": submitted && !data.status })}
                                        />
                                        <label htmlFor="pumpReadyToUseCheckbox1" style={{ marginRight: ".5rem" }}>
                                            ผ่าน
                                        </label>
                                    </div> */}
                                </div>
                                {/* <div className="p-col-12 p-md-2">
                                    <div className="p-field-radiobutton" style={{ marginTop: "0.45rem", marginBottom: "0.45rem" }}>
                                        <RadioButton
                                            inputId="pumpReadyToUseCheckbox_2"
                                            name="pumpReadyToUseCheckbox"
                                            value="2"
                                            onChange={(e) => onInputTextChange(e, "pumpReadyToUseCheckbox")}
                                            checked={data.pumpReadyToUseCheckbox === "2" ? true : false}
                                            disabled={data[item.id] === "N" || disabledPage}
                                            //className="p-invalid" className={classNames({ "p-invalid": submitted && !data.status })}
                                        />
                                        <label htmlFor="pumpReadyToUseCheckbox2" style={{ marginRight: ".5rem" }}>
                                            ไม่ผ่าน
                                        </label>
                                    </div>
                                </div> */}
                                {/* <div className="p-col-12 p-md-3">
                                    <div className="p-field-radiobutton" style={{ marginTop: "0.45rem", marginBottom: "0.45rem" }}>
                                        <RadioButton
                                            inputId="pumpReadyToUseCheckbox_3"
                                            name="pumpReadyToUseCheckbox"
                                            value="3"
                                            onChange={(e) => onInputTextChange(e, "pumpReadyToUseCheckbox")}
                                            checked={data.pumpReadyToUseCheckbox === "3" ? true : false}
                                            disabled={data[item.id] === "N" || disabledPage}
                                            //className="p-invalid" className={classNames({ "p-invalid": submitted && !data.status })}
                                        />
                                        <label htmlFor="pumpReadyToUseCheckbox3" style={{ marginRight: ".5rem" }}>
                                            ไม่ได้ตรวจ
                                        </label>
                                    </div>
                                    
                                </div>
                                 */}
                            </div>
                        </>
                    ) : (
                        ""
                    )}
                </>
            );
        });
    };

    return (
        <div>
            <div className="p-grid  p-fluid">
                <div className="p-col-12 p-md-6">
                    <h5 className="p-no-box line-under">
                        <b>ความเห็น</b> แรงงาน และเครื่องจักร
                    </h5>
                    {renderLeft()}
                    {/* End L */}
                </div>

                {/* right */}
                <div className="p-col-12 p-md-6">
                    <h5 className="p-no-box line-under">
                        <b>ความเห็น</b> แรงงาน
                    </h5>
                    <div className="p-grid p-fluid p-no-box">
                        <div className="p-col-12 p-md-1"></div>
                        <div className="p-col-12 p-md-6">
                            <div className="flex justify-content-center">
                                <SelectButton 
                                optionLabel="label" 
                                options={commentOnWorkerOptions} 
                                value={data.commentOnWorker} 
                                onChange={(e) => onInputTextChange(e, "commentOnWorker")} 
                                optionValue="value" 
                                disabled={disabledPage} />
                            </div>
                            {/* <div className="p-field-radiobutton" style={{ marginTop: "0.45rem", marginBottom: "0.45rem" }}>
                                <RadioButton
                                    inputId="commentOnWorker_1"
                                    name="commentOnWorker"
                                    value="Y"
                                    onChange={(e) => onCommentOnWorkerChange(e, "commentOnWorker")}
                                    checked={data.commentOnWorker === "Y" ? true : false}
                                    disabled={disabledPage}
                                    //className="p-invalid" className={classNames({ "p-invalid": submitted && !data.status })}
                                />
                                <label htmlFor="appointment_location1" style={{ marginRight: ".5rem" }}>
                                    เพียงพอ
                                </label>
                            </div> */}
                        </div>
                        {/* <div className="p-col-12 p-md-1"></div>
                        <div className="p-col-12 p-md-6">
                            <div className="p-field-radiobutton" style={{ marginTop: "0.45rem", marginBottom: "0.45rem" }}>
                                <RadioButton
                                    inputId="commentOnWorker_2"
                                    name="commentOnWorker"
                                    value="N"
                                    onChange={(e) => onCommentOnWorkerChange(e, "commentOnWorker")}
                                    checked={data.commentOnWorker === "N" ? true : false}
                                    disabled={disabledPage}
                                    //className="p-invalid" className={classNames({ "p-invalid": submitted && !data.status })}
                                />
                                <label htmlFor="appointment_location1" style={{ marginRight: ".5rem" }}>
                                    ไม่พบผู้ปฏิบัติงาน ดังนี้
                                </label>
                            </div>
                        </div>
                        <div className="p-col-12 p-md-2"></div> */}
                    </div>

                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-5"></div>
                        <div className="p-col-12 p-md-4">
                            <div className="p-field-checkbox">
                                <Checkbox inputId="commentEngineer" name="commentEngineer" value="Y" disabled={!disabledPage && data.commentOnWorker === "N" ? false : true} checked={data.commentEngineer === "Y" ? true : false} onChange={(e) => onInputTextChange(e, "commentEngineer")} />
                                <label htmlFor="commentEngineer">วิศวกรสนาม</label>
                            </div>
                        </div>
                        <div className="p-col-12 p-md-3"></div>
                    </div>

                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-5"></div>
                        <div className="p-col-12 p-md-4">
                            <div className="p-field-checkbox">
                                <Checkbox inputId="commentForeman" name="commentForeman" value="Y" disabled={!disabledPage && data.commentOnWorker === "N" ? false : true} checked={data.commentForeman === "Y" ? true : false} onChange={(e) => onInputTextChange(e, "commentForeman")} />
                                <label htmlFor="commentForeman">หัวหน้าคนงาน</label>
                            </div>
                        </div>
                        <div className="p-col-12 p-md-3"></div>
                    </div>

                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-5"></div>
                        <div className="p-col-12 p-md-4">
                            <div className="p-field-checkbox">
                                <Checkbox inputId="commentPipeFitter" name="commentPipeFitter" value="Y" disabled={!disabledPage && data.commentOnWorker === "N" ? false : true} checked={data.commentPipeFitter === "Y" ? true : false} onChange={(e) => onInputTextChange(e, "commentPipeFitter")} />
                                <label htmlFor="">ช่างประกอบท่อ</label>
                            </div>
                        </div>
                        <div className="p-col-12 p-md-3"></div>
                    </div>

                    <h5 className="p-no-box line-under">
                        <b>ความเห็น</b> เครื่องจักร/เครื่องมือ
                    </h5>
                    <div className="p-grid p-fluid p-no-box">
                        <div className="p-col-12 p-md-1"></div>
                        <div className="p-col-12 p-md-6">
                        <div className="flex justify-content-center">
                                <SelectButton 
                                optionLabel="label" 
                                options={commentToolsOptions} 
                                value={data.commentTools} 
                                onChange={(e) => onInputTextChange(e, "commentTools")} 
                                optionValue="value" 
                                disabled={disabledPage} />
                            </div>
                            {/* <div className="p-field-radiobutton" style={{ marginTop: "0.45rem", marginBottom: "0.45rem" }}>
                                <RadioButton
                                    inputId="commentTools_1"
                                    name="commentTools"
                                    value="Y"
                                    onChange={(e) => onCommentToolsChange(e, "commentTools")}
                                    checked={data.commentTools === "Y" ? true : false}
                                    disabled={disabledPage}
                                    // checked={data.status === "A"} className="p-invalid" className={classNames({ "p-invalid": submitted && !data.status })}
                                />
                                <label htmlFor="commentTools_1" style={{ marginRight: ".5rem" }}>
                                    เพียงพอ
                                </label>
                            </div> */}
                        </div>

                        {/* <div className="p-col-12 p-md-1"></div>
                        <div className="p-col-12 p-md-6">
                            <div className="p-field-radiobutton" style={{ marginTop: "0.45rem", marginBottom: "0.45rem" }}>
                                <RadioButton
                                    inputId="commentTools_2"
                                    name="commentTools"
                                    value="N"
                                    onChange={(e) => onCommentToolsChange(e, "commentTools")}
                                    checked={data.commentTools === "N" ? true : false}
                                    disabled={disabledPage}
                                    // className="p-invalid" className={classNames({ "p-invalid": submitted && !data.status })}
                                />
                                <label htmlFor="commentTools_2" style={{ marginRight: ".5rem" }}>
                                    ปรับปรุง/แก้ไข
                                </label>
                            </div>
                        </div>
                        <div className="p-col-12 p-md-2"></div> */}
                    </div>

                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-5"></div>
                        <div className="p-col-12 p-md-4">
                            <div className="p-field-checkbox">
                                <Checkbox inputId="commentBackhoe" name="commentBackhoe" value="Y" disabled={!disabledPage && data.commentTools === "N" ? false : true} checked={data.commentBackhoe === "Y" ? true : false} onChange={(e) => onInputTextChange(e, "commentBackhoe")} />
                                <label htmlFor="commentBackhoe">รถขุดดิน</label>
                            </div>
                        </div>
                        <div className="p-col-12 p-md-2">
                            {data.commentBackhoe === "Y" && !display_mode() ? (
                                <img title="อัปโหลดรูป" alt="อัปโหลดรูป" src="assets/layout/images/Upload_a_picture.png" style={{ width: 35, height: 35 }} onClick={() => uploadPic("T150")} />
                            ) : (
                                <img title="อัปโหลดรูป" alt="อัปโหลดรูป" src="assets/layout/images/Upload_a_picture.png" style={{ width: 35, height: 35 }} />
                            )}
                            {data.commentBackhoe === "Y" ? (
                                <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} onClick={() => onUploadDialog("T150")} />
                            ) : (
                                <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} />
                            )}
                            {/* <Button className="p-button-info p-button p-md-12 " icon="pi pi-image" label="รูปถ่าย" disabled={data.commentBackhoe === "Y" ? false : true} style={{ marginLeft: "5px" }} onClick={() => onUploadDialog("T150")} /> */}
                        </div>
                        {/* <div className="p-col-12 p-md-1">
                            <Button className="p-button-info p-button p-md-12 " icon="pi pi-image" label="รูปถ่าย" disabled={data.commentBackhoe === "Y" ? false : true} style={{ marginLeft: "5px" }} onClick={() => onUploadDialog("T150")} />
                        </div> */}
                    </div>
                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-5"></div>
                        <div className="p-col-12 p-md-4">
                            <div className="p-field-checkbox">
                                <Checkbox
                                    inputId="commentSandCompactor"
                                    name="commentSandCompactor"
                                    value="Y"
                                    disabled={!disabledPage && data.commentTools === "N" ? false : true}
                                    checked={data.commentSandCompactor === "Y" ? true : false}
                                    onChange={(e) => onInputTextChange(e, "commentSandCompactor")}
                                />
                                <label htmlFor="commentSandCompactor">เครื่องบดอัดทราย/ดิน</label>
                            </div>
                        </div>
                        <div className="p-col-12 p-md-2">
                            {data.commentSandCompactor === "Y" && !display_mode() ? (
                                <img title="อัปโหลดรูป" alt="อัปโหลดรูป" src="assets/layout/images/Upload_a_picture.png" style={{ width: 35, height: 35 }} onClick={() => uploadPic("T151")} />
                            ) : (
                                <img title="อัปโหลดรูป" alt="อัปโหลดรูป" src="assets/layout/images/Upload_a_picture.png" style={{ width: 35, height: 35 }} />
                            )}
                            {data.commentSandCompactor === "Y" ? (
                                <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} onClick={() => onUploadDialog("T151")} />
                            ) : (
                                <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} />
                            )}
                            {/* <Button className="p-button-info p-button p-md-12 " icon="pi pi-image" label="รูปถ่าย" style={{ marginLeft: "5px" }} disabled={data.commentSandCompactor === "Y" ? false : true} onClick={() => onUploadDialog("T151")} /> */}
                        </div>
                        {/* <div className="p-col-12 p-md-1">
                            {/* <Button className="p-button-info p-button p-md-12 " icon="pi pi-image" label="รูปถ่าย" style={{ marginLeft: "5px" }} disabled={data.commentSandCompactor === "Y" ? false : true} onClick={() => onUploadDialog("T151")} /> */}
                        {/* </div> */}
                    </div>
                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-5"></div>
                        <div className="p-col-12 p-md-4">
                            <div className="p-field-checkbox">
                                <Checkbox inputId="commentPump" name="commentPump" value="Y" disabled={!disabledPage && data.commentTools === "N" ? false : true} checked={data.commentPump === "Y" ? true : false} onChange={(e) => onInputTextChange(e, "commentPump")} />
                                <label htmlFor="commentPump">เครื่องสูบน้ำ</label>
                            </div>
                        </div>
                        <div className="p-col-12 p-md-2">
                            {data.commantPump === "Y" && !display_mode() ? (
                                <img title="อัปโหลดรูป" alt="อัปโหลดรูป" src="assets/layout/images/Upload_a_picture.png" style={{ width: 35, height: 35 }} onClick={() => uploadPic("T152")} />
                            ) : (
                                <img title="อัปโหลดรูป" alt="อัปโหลดรูป" src="assets/layout/images/Upload_a_picture.png" style={{ width: 35, height: 35 }} />
                            )}
                            {data.commantPump === "Y" ? (
                                <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} onClick={() => onUploadDialog("T152")} />
                            ) : (
                                <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} />
                            )}
                            {/* <Button className="p-button-info p-button p-md-12 " icon="pi pi-image" label="รูปถ่าย" style={{ marginLeft: "5px" }} disabled={data.commantPump === "Y" ? false : true} onClick={() => onUploadDialog("T152")} /> */}
                        </div>
                        {/* <div className="p-col-12 p-md-1">
                            {/* <Button className="p-button-info p-button p-md-12 " icon="pi pi-image" label="รูปถ่าย" style={{ marginLeft: "5px" }} disabled={data.commantPump === "Y" ? false : true} onClick={() => onUploadDialog("T152")} /> */}
                        {/* </div> */}
                    </div>

                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-5"></div>
                        <div className="p-col-12 p-md-4">
                            <div className="p-field-checkbox">
                                <Checkbox inputId="commentOther" name="commentOther" value="Y" disabled={!disabledPage && data.commentTools === "N" ? false : true} checked={data.commentOther === "Y" ? true : false} onChange={(e) => onInputTextChange(e, "commentOther")} />
                                <label htmlFor="commentOther">อื่นๆ</label>
                            </div>
                        </div>
                        <div className="p-col-12 p-md-2">
                            {data.commentOther === "Y" && !display_mode() ? (
                                <img title="อัปโหลดรูป" alt="อัปโหลดรูป" src="assets/layout/images/Upload_a_picture.png" style={{ width: 35, height: 35 }} onClick={() => uploadPic("T153")} />
                            ) : (
                                <img title="อัปโหลดรูป" alt="อัปโหลดรูป" src="assets/layout/images/Upload_a_picture.png" style={{ width: 35, height: 35 }} />
                            )}
                            {data.commentOther === "Y" ? (
                                <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} onClick={() => onUploadDialog("T153")} />
                            ) : (
                                <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} />
                            )}

                            {/* <Button className="p-button-info p-button p-md-12 " icon="pi pi-image" label="รูปถ่าย" style={{ marginLeft: "5px" }} disabled={data.commentOther === "Y" ? false : true} oonClick={() => onUploadDialog("T153")} /> */}
                        </div>
                        <div className="p-col-12 p-md-1">{/* <Button className="p-button-info p-button p-md-12 " icon="pi pi-image" label="รูปถ่าย" style={{ marginLeft: "5px" }} disabled={data.commentOther === "Y" ? false : true} oonClick={() => onUploadDialog("T153")} /> */}</div>
                    </div>

                    <h5 className="p-no-box line-under">
                        <b>บันทึกความก้าวหน้า</b>
                    </h5>
                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-12">
                            <div className="p-inputgroup">
                                <InputTextarea value={data.inspectNote} rows={5} cols={30} autoResize maxLength="5000" onChange={(e) => onInputTextChange(e, "inspectNote")} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
